import Header from '../../components/feature/Header';
import Hero from './sections/Hero';
import About from './sections/About';
import CompanyProfile from './sections/CompanyProfile';
import Partnership from './sections/Partnership';
import Business from './sections/Business';
import Strengths from './sections/Strengths';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main itemScope itemType="https://schema.org/WebPage">
        <Hero />
        <About />
        <CompanyProfile />
        <Partnership />
        <Business />
        <Strengths />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
